module.exports = __webpack_public_path__ + "img/profile_man.33a3b2db.png";